import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propShape } from '../../../../../../helpers/custom-prop-types';
import { useKanaEffect } from '../../../../../../helpers/use/useKana';
import { validateFirstName, validateLastName, } from '../../../../../../validate/common';
import PlainInputComponent from '../../../../Common/PlainInputComponent';
/**
 * 氏名部分を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchFormNameField = (props) => {
    const { kanaRef } = props;
    useKanaEffect(kanaRef);
    return (_jsxs("div", Object.assign({ className: 'name_row' }, { children: [_jsxs("div", Object.assign({ className: 'row_item' }, { children: [_jsx("div", Object.assign({ className: 'row_title' }, { children: "\u59D3" })), _jsx(Field, { className: 'form_input input-form-text', component: PlainInputComponent, id: 'lastName', name: 'lastName', placeholder: '田中', validate: validateLastName })] })), _jsxs("div", Object.assign({ className: 'row_item' }, { children: [_jsx("div", Object.assign({ className: 'row_title' }, { children: "\u540D" })), _jsx(Field, { className: 'form_input input-form-text', component: PlainInputComponent, id: 'firstName', name: 'firstName', placeholder: '太郎', validate: validateFirstName })] }))] })));
};
SlideSearchFormNameField.propTypes = {
    kanaRef: propShape().isRequired,
};
export default SlideSearchFormNameField;
